import styled from "styled-components";

export const OrganizacjaElementStyle = styled.div`
  background-color: ${(props) => props.theme.palette.background.paper};
  padding: 24px 24px 12px 24px;
  height: 212px;
  display: grid;
  border-radius: 3px;
  box-shadow: 1px 2px 3px 0 rgba(0, 0, 0, 0.04);

  h4 {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .kafel__tytul {
    display: grid;
    grid-template-columns: 1fr 36px;
  }

  .kafel__opis {
    display: grid;
    align-content: start;
  }

  .kafel__stopka {
    display: grid;
    height: 32px;
    grid-template-columns: 1fr 104px;
    align-self: end;

    button {
      background-color: transparent;
      color: #10a886;
      border: solid 1px #10a886;
      outline: none;
      box-shadow: none;
      cursor: pointer;
      height: 32px;
    }

    .selected {
      background-color: #10a886;
      color: #fff;
      display: grid;
      align-items: center;
      justify-items: center;
    }
  }
`;
